module.exports = __webpack_public_path__ + "static/img/19.ab68a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/19.jpg
// module id = 7SZj
// module chunks = 1